<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Importar Factura XML" />

    <div class="flex-grow-1 overflow-auto px-3 pb-3">

      <!-- Upload + Info -->
      <div v-if="!resultado" class="row g-3 mb-3">
        <div class="col-md-7">
          <div class="card h-100">
            <div class="card-body">
              <h6 class="card-title mb-3">
                Cargar archivos de la factura
                <span class="badge ms-2" style="font-size:10px;background:linear-gradient(135deg,#6366f1,#4f46e5);color:#fff;vertical-align:middle">BETA</span>
              </h6>
              <!-- Zona XML -->
              <div class="mb-3">
                <label class="form-label small fw-semibold mb-1">
                  Archivo XML <span class="text-danger">*</span>
                </label>
                <div class="drop-zone" :class="{ 'dz-over': dragOverXml, 'dz-filled': archivoXml, 'dz-error': errorXml }"
                  @dragover.prevent="dragOverXml = true"
                  @dragleave="dragOverXml = false"
                  @drop.prevent="onDropXml"
                  @click="$refs.inputXml.click()">
                  <input ref="inputXml" type="file" accept=".xml" class="d-none" @change="onXmlChange" />
                  <div v-if="!archivoXml" class="dz-prompt">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    <span class="dz-label">{{ dragOverXml ? 'Suelta aquí' : 'Arrastra el XML aquí o haz clic' }}</span>
                    <span class="dz-hint">Solo archivos .xml</span>
                  </div>
                  <div v-else class="dz-file-name">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#198754" stroke-width="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                    {{ archivoXml.name }}
                    <button class="dz-clear" @click.stop="clearXml" title="Quitar">✕</button>
                  </div>
                </div>
                <div v-if="errorXml" class="form-text text-danger mt-1">{{ errorXml }}</div>
              </div>

              <!-- Zona PDF -->
              <div class="mb-3">
                <label class="form-label small fw-semibold mb-1">
                  Archivo PDF <span class="text-muted fw-normal">(opcional — auto-detecta tallas)</span>
                </label>
                <div class="drop-zone" :class="{ 'dz-over': dragOverPdf, 'dz-filled': archivoPdf, 'dz-error': errorPdf }"
                  @dragover.prevent="dragOverPdf = true"
                  @dragleave="dragOverPdf = false"
                  @drop.prevent="onDropPdf"
                  @click="$refs.inputPdf.click()">
                  <input ref="inputPdf" type="file" accept=".pdf" class="d-none" @change="onPdfChange" />
                  <div v-if="!archivoPdf" class="dz-prompt">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                    <span class="dz-label">{{ dragOverPdf ? 'Suelta aquí' : 'Arrastra el PDF aquí o haz clic' }}</span>
                    <span class="dz-hint">Solo archivos .pdf</span>
                  </div>
                  <div v-else class="dz-file-name">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="#198754" stroke-width="2" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>
                    {{ archivoPdf.name }}
                    <button class="dz-clear" @click.stop="clearPdf" title="Quitar">✕</button>
                  </div>
                </div>
                <div v-if="errorPdf" class="form-text text-danger mt-1">{{ errorPdf }}</div>
              </div>
              <button class="btn btn-primary" :disabled="!archivoXml || cargando" @click="parsear">
                <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
                {{ cargando ? 'Analizando…' : 'Analizar' }}
              </button>
              <div v-if="error" class="alert alert-danger mt-3 mb-0">{{ error }}</div>
            </div>
          </div>
        </div>

        <div class="col-md-5">
          <div class="card h-100 border-info">
            <div class="card-body">
              <h6 class="card-title text-info mb-3">¿Qué archivos debo subir?</h6>
              <div class="small mb-3">
                <div class="fw-semibold mb-1">XML (obligatorio):</div>
                <p class="mb-0">El archivo electrónico SUNAT UBL 2.1 — contiene RUC, productos, montos.</p>
              </div>
              <div class="small mb-3">
                <div class="fw-semibold mb-1">PDF (recomendado):</div>
                <p class="mb-0">La factura en PDF del proveedor. Se lee automáticamente el desglose de tallas por producto.</p>
              </div>
              <div class="small mb-3">
                <div class="fw-semibold mb-1">Proveedores compatibles:</div>
                <div class="d-flex gap-2 flex-wrap">
                  <span class="badge bg-light text-dark border">Adidas</span>
                  <span class="badge bg-light text-dark border">Nike</span>
                  <span class="badge bg-light text-dark border">Puma</span>
                  <span class="badge bg-light text-dark border">Umbro</span>
                  <span class="badge bg-light text-dark border">y otros...</span>
                </div>
              </div>
              <div class="alert alert-warning py-2 px-3 mb-0 small">
                <strong>¿No tienes el XML?</strong> Pídelo al proveedor. Suele venir adjunto al PDF por correo.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Preview -->
      <template v-if="resultado">
        <!-- Cabecera factura -->
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h6 class="card-title mb-2">
                  Factura {{ resultado.factura.serie }}-{{ resultado.factura.numero }}
                  <span class="badge bg-secondary ms-2">{{ resultado.factura.moneda }}</span>
                </h6>
                <p class="mb-1 small">
                  <strong>Proveedor:</strong>
                  <template v-if="resultado.factura.proveedor">
                    {{ resultado.factura.proveedor.razonsocial }}
                    <span class="text-muted">(id {{ resultado.factura.proveedor.idpersona }})</span>
                  </template>
                  <template v-else>
                    <span class="text-danger">
                      {{ resultado.factura.nombreProveedorXml }} — RUC {{ resultado.factura.rucProveedor }} no encontrado
                    </span>
                  </template>
                </p>
                <p class="mb-1 small"><strong>Fecha:</strong> {{ resultado.factura.fecha }}</p>
              </div>
              <div class="text-end">
                <div class="small text-muted">Subtotal: S/ {{ fmt(resultado.factura.subtotal) }}</div>
                <div class="small text-muted">IGV (18%): S/ {{ fmt(resultado.factura.igv) }}</div>
                <div class="fw-bold">Total: S/ {{ fmt(resultado.factura.total) }}</div>
              </div>
            </div>
            <!-- Resumen badges -->
            <div class="mt-2 small text-muted">
              <span class="text-success">✓ {{ resultado.resumen.productos_existentes }} existentes</span><span class="text-muted">, </span>
              <span :class="resultado.resumen.productos_nuevos > 0 ? 'text-warning' : 'text-muted'">{{ resultado.resumen.productos_nuevos > 0 ? '⚠' : '✓' }} {{ resultado.resumen.productos_nuevos }} nuevos</span>
              <template v-if="resultado.resumen.auto_llenados > 0"><span class="text-muted">, </span><span class="text-info">✦ {{ resultado.resumen.auto_llenados }} tallas auto-detectadas del PDF</span></template>
              <template v-if="resultado.resumen.con_discrepancias > 0"><span class="text-muted">, </span><span class="text-warning">⚠ {{ resultado.resumen.con_discrepancias }} con diferencia entre PDF y factura</span></template>
            </div>
          </div>
        </div>

        <!-- Alerta de discrepancias + exportar -->
        <div v-if="resultado.resumen.con_discrepancias > 0" class="alert alert-warning mb-3">
          <strong>⚠ {{ resultado.resumen.con_discrepancias }} productos con diferencia entre PDF y factura.</strong>
          <div class="small mt-1">Las filas en amarillo tienen cantidades que no cuadran. Puedes ajustarlas manualmente antes de confirmar.</div>
        </div>

        <!-- Configuración de la compra -->
        <div class="card mb-3">
          <div class="card-body">
            <h6 class="card-title mb-3">Configuración de la compra</h6>
            <div class="row g-2">
              <div class="col-md-2">
                <label class="form-label mb-1 small fw-semibold">Almacén</label>
                <select v-model="config.idalmacen" class="form-select form-select-sm">
                  <option :value="1">Lapoint 939</option>
                  <option :value="15">Lapoint 1179 / 1155</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label mb-1 small fw-semibold">Tipo Doc.</label>
                <select v-model="config.idtipodoc" class="form-select form-select-sm">
                  <option :value="2">Factura</option>
                  <option :value="1">Boleta</option>
                </select>
              </div>
              <div class="col-md-2">
                <label class="form-label mb-1 small fw-semibold">Fecha recepción</label>
                <input v-model="config.fecha_recep" type="date" class="form-control form-control-sm" />
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla de items -->
        <div class="card mb-3">
          <div class="card-header py-2">
            <h6 class="mb-0 small fw-semibold">
              Productos
              <span v-if="resultado.resumen.auto_llenados > 0" class="text-info fw-normal ms-2">
                — tallas detectadas automáticamente del PDF (puedes editarlas)
              </span>
              <span v-else class="text-muted fw-normal ms-2">
                — ingresa el desglose de tallas manualmente (ej: <code>4/2 5/2 6/4</code>)
              </span>
            </h6>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-sm table-hover mb-0 align-middle">
                <thead class="table-light">
                  <tr>
                    <th class="ps-3">#</th>
                    <th>Cód. Prov.</th>
                    <th>Descripción</th>
                    <th class="text-center">Qty</th>
                    <th class="text-end">P. Unit (S/)</th>
                    <th style="min-width:240px">Desglose tallas</th>
                    <th class="text-center">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in items" :key="i"
                      :class="rowClass(item)">
                    <td class="ps-3 text-muted small">{{ i + 1 }}</td>
                    <td><code class="small">{{ item.codigo_prov }}</code></td>
                    <td class="small">{{ item.descripcion }}</td>
                    <td class="text-center">{{ parseInt(item.cantidad) }}</td>
                    <td class="text-end small">{{ fmt(item.precioUnitario) }}</td>
                    <td>
                      <template v-if="item.tallasEditables && item.tallasEditables.length">
                        <div class="d-flex flex-wrap gap-2 align-items-center">
                          <div v-for="(t, ti) in item.tallasEditables" :key="ti"
                               class="d-flex flex-column align-items-center"
                               style="min-width:42px">
                            <span class="small text-muted" style="font-size:10px;line-height:1.2">{{ t.talla }}</span>
                            <input
                              v-model.number="t.cantidad"
                              type="number"
                              min="0"
                              class="form-control form-control-sm text-center p-1"
                              style="width:42px;font-size:13px"
                              :class="sumaTallasEditables(item) === item.cantidad ? 'border-success' : 'border-warning'"
                            />
                          </div>
                          <span class="small ms-1 text-nowrap"
                                :class="sumaTallasEditables(item) === item.cantidad ? 'text-success' : 'text-warning'">
                            {{ sumaTallasEditables(item) }}/{{ item.cantidad }}
                          </span>
                        </div>
                      </template>
                      <span v-else class="text-muted small">—</span>
                    </td>
                    <td class="text-center" style="min-width:130px">
                      <template v-if="!item.tallasEditables?.length">
                        <span class="badge bg-secondary-subtle text-secondary">Sin tallas en PDF</span>
                      </template>
                      <template v-else-if="sumaTallasEditables(item) === item.cantidad">
                        <span class="badge bg-info-subtle text-info">Auto ✓</span>
                      </template>
                      <template v-else>
                        <span class="badge bg-warning-subtle text-warning">
                          ⚠ {{ sumaTallasEditables(item) }}/{{ item.cantidad }}
                        </span>
                        <div class="small text-muted mt-1" style="font-size:10px">Faltan {{ item.cantidad - sumaTallasEditables(item) }} en PDF</div>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="hayDesgloseIncorrecto" class="alert alert-warning mb-3">
          Algunos totales de tallas no coinciden con la cantidad del XML. Verifica antes de confirmar.
        </div>
        <div v-if="resultado.resumen.productos_nuevos > 0" class="alert alert-warning mb-3">
          <strong>{{ resultado.resumen.productos_nuevos }} productos nuevos</strong> — se crearán automáticamente. Edítalos luego en Productos.
        </div>
        <div v-if="errorRegistro" class="alert alert-danger mb-3">{{ errorRegistro }}</div>

        <div class="d-flex gap-2">
          <button class="btn btn-success" :disabled="registrando || hayDesgloseIncorrecto" @click="confirmar">
            <span v-if="registrando" class="spinner-border spinner-border-sm me-1"></span>
            {{ registrando ? 'Registrando…' : 'Confirmar e importar compra' }}
          </button>
          <button class="btn btn-outline-secondary" :disabled="registrando" @click="reiniciar">Cancelar / cargar otros archivos</button>
        </div>
        <p v-if="!resultado.factura.proveedor" class="text-info small mt-2">
          El proveedor no existe todavía. Al confirmar se creará desde el XML con RUC {{ resultado.factura.rucProveedor }}.
        </p>
      </template>

    </div>
  </div>
</template>

<script>
import MainHeader from '../../components/Layouts/MainHeader.vue';
import MainSidebar from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import api from '../../services/api';

export default {
  name: 'ImportarXmlPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu },
  data() {
    return {
      archivoXml: null,
      archivoPdf: null,
      dragOverXml: false,
      dragOverPdf: false,
      errorXml: null,
      errorPdf: null,
      cargando: false,
      error: null,
      resultado: null,
      items: [],
      registrando: false,
      errorRegistro: null,
      intentoConfirmar: false,
      config: {
        idalmacen: 1,
        idtipodoc: 2,
        fecha_recep: new Date().toISOString().slice(0, 10),
      },
    };
  },

  computed: {
    hayDesgloseIncorrecto() {
      return this.items.some(item =>
        item.tallasEditables?.length > 0 &&
        this.sumaTallasEditables(item) !== item.cantidad
      );
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.advertirSalida);
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.advertirSalida);
  },
  beforeRouteLeave(_to, _from, next) {
    if (!this.registrando || window.confirm('La compra se está registrando. ¿Deseas salir y dejar de esperar la confirmación?')) next();
    else next(false);
  },
  methods: {
    advertirSalida(event) {
      if (!this.registrando) return;
      event.preventDefault();
      event.returnValue = '';
    },
    fmt(v) { return Number(v || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
    parsearTallas(str) {
      if (!str || !str.trim()) return [];
      return str.trim().split(/\s+/).map(part => {
        const [talla, cant] = part.split('/');
        return { talla: talla?.trim(), cantidad: parseInt(cant) || 0 };
      }).filter(t => t.talla && t.cantidad > 0);
    },
    sumaTallas(item) {
      return this.parsearTallas(item.tallas_desglose).reduce((s, t) => s + t.cantidad, 0);
    },
    sumaTallasEditables(item) {
      return (item.tallasEditables || []).reduce((s, t) => s + (t.cantidad || 0), 0);
    },
    tallasValidas(item) {
      return this.sumaTallasEditables(item) === item.cantidad;
    },
    rowClass(item) {
      if (!item.tallasEditables?.length) return '';
      return this.sumaTallasEditables(item) === item.cantidad ? '' : 'table-warning';
    },
    onXmlChange(e) {
      const f = e.target.files[0];
      if (f && !f.name.toLowerCase().endsWith('.xml')) {
        this.errorXml = `"${f.name}" no es un XML. Solo se aceptan archivos .xml`;
        this.$refs.inputXml.value = '';
        this.archivoXml = null;
      } else {
        this.errorXml = null;
        this.archivoXml = f || null;
        this.error = null;
      }
    },
    onPdfChange(e) {
      const f = e.target.files[0];
      if (f && !f.name.toLowerCase().endsWith('.pdf')) {
        this.errorPdf = `"${f.name}" no es un PDF. Solo se aceptan archivos .pdf`;
        this.$refs.inputPdf.value = '';
        this.archivoPdf = null;
      } else {
        this.errorPdf = null;
        this.archivoPdf = f || null;
      }
    },
    onDropXml(e) {
      this.dragOverXml = false;
      const f = e.dataTransfer.files[0];
      if (!f) return;
      if (!f.name.toLowerCase().endsWith('.xml')) {
        this.errorXml = `"${f.name}" no es un XML. Solo se aceptan archivos .xml`;
        return;
      }
      this.errorXml = null;
      this.archivoXml = f;
      this.error = null;
    },
    onDropPdf(e) {
      this.dragOverPdf = false;
      const f = e.dataTransfer.files[0];
      if (!f) return;
      if (!f.name.toLowerCase().endsWith('.pdf')) {
        this.errorPdf = `"${f.name}" no es un PDF. Solo se aceptan archivos .pdf`;
        return;
      }
      this.errorPdf = null;
      this.archivoPdf = f;
    },
    clearXml() { this.archivoXml = null; this.errorXml = null; if (this.$refs.inputXml) this.$refs.inputXml.value = ''; },
    clearPdf() { this.archivoPdf = null; this.errorPdf = null; if (this.$refs.inputPdf) this.$refs.inputPdf.value = ''; },
    async parsear() {
      if (!this.archivoXml) return;
      this.cargando = true;
      this.error = null;
      try {
        const fd = new FormData();
        fd.append('xml', this.archivoXml);
        if (this.archivoPdf) fd.append('pdf', this.archivoPdf);
        const res = await api.post('/compras/parsear-xml', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.resultado = res.data.data;
        this.items = (this.resultado.items || []).map(it => ({
          ...it,
          tallasEditables: this.parsearTallas(it.tallas_desglose || ''),
        }));
      } catch (e) {
        this.error = e.response?.data?.error || e.message;
      } finally {
        this.cargando = false;
      }
    },
    async confirmar() {
      this.registrando = true;
      this.errorRegistro = null;
      try {
        const fd = new FormData();
        fd.append('xml', this.archivoXml);
        fd.append('idalmacen', this.config.idalmacen);
        fd.append('idtipodoc', this.config.idtipodoc);
        fd.append('fecha_recep', this.config.fecha_recep);
        const itemsPayload = this.items.map(it => ({
          codigo_prov:     it.codigo_prov,
          tallas_desglose: (it.tallasEditables || []).map(t => `${t.talla}/${t.cantidad}`).join(' '),
        }));
        fd.append('items', JSON.stringify(itemsPayload));
        await api.post('/compras/confirmar-xml', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        this.$router.push('/purchase-list');
      } catch (e) {
        this.errorRegistro = e.response?.data?.error || e.message;
      } finally {
        this.registrando = false;
      }
    },
    exportarDiscrepancias() {
      const filas = this.items
        .filter(it => it.discrepancias_talla?.length > 0)
        .map(it => [
          it.codigo_prov,
          it.descripcion,
          it.discrepancias_talla.join(' | '),
          it.tallas_bd.map(t => t.talla_num).join(' | '),
        ]);
      const header = ['Código', 'Descripción', 'Tallas PDF (no registradas)', 'Tallas en BD'];
      const csv = [header, ...filas].map(r => r.map(c => `"${c}"`).join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `discrepancias_${this.resultado.factura.serie}-${this.resultado.factura.numero}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    },
    reiniciar() {
      if (this.registrando) return;
      this.resultado = null;
      this.items = [];
      this.archivoXml = null;
      this.archivoPdf = null;
      this.error = null;
      this.errorRegistro = null;
      if (this.$refs.inputXml) this.$refs.inputXml.value = '';
      if (this.$refs.inputPdf) this.$refs.inputPdf.value = '';
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #ced4da;
  border-radius: 8px;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  background: #fafafa;
  user-select: none;
}
.drop-zone:hover,
.drop-zone.dz-over {
  border-color: #4f46e5;
  background: #f0f0ff;
}
.drop-zone.dz-filled {
  border-color: #198754;
  border-style: solid;
  background: #f0faf4;
}
.drop-zone.dz-error {
  border-color: #dc3545;
  background: #fff5f5;
}
.dz-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  color: #6c757d;
}
.drop-zone:hover .dz-prompt,
.drop-zone.dz-over .dz-prompt {
  color: #4f46e5;
}
.dz-label {
  font-size: 0.875rem;
  font-weight: 500;
}
.dz-hint {
  font-size: 0.75rem;
  color: #adb5bd;
}
.dz-file-name {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #198754;
}
.dz-clear {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 0.75rem;
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.dz-clear:hover { opacity: 0.7; }
</style>
